import { Logo } from "@/components/Navbar";

export default function Footer() {
  return (
    <footer className="border-t border-border bg-foreground text-white">
      <div className="mx-auto max-w-7xl px-5 py-14 lg:px-8">
        <div className="grid gap-10 md:grid-cols-3">
          <div>
            <Logo dark />
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-white/60">
              Software de punto de venta profesional para comercios y restaurantes. Vende directo o conviértete en distribuidor.
            </p>
          </div>
          <div>
            <p className="overline text-white/40">Productos</p>
            <ul className="mt-4 space-y-2 text-sm text-white/70">
              <li>ProfesionalPOS</li>
              <li>ProfesionalPOS Restaurante</li>
            </ul>
          </div>
          <div>
            <p className="overline text-white/40">Canales</p>
            <ul className="mt-4 space-y-2 text-sm text-white/70">
              <li>Planes mensuales y anuales</li>
              <li>Distribuidores · 15% a 35% de descuento</li>
            </ul>
          </div>
        </div>
        <div className="mt-12 border-t border-white/10 pt-6 text-xs text-white/40">
          © {new Date().getFullYear()} Pro Core Digital. Todos los derechos reservados.
        </div>
      </div>
    </footer>
  );
}
